// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_CnL","cls2":"FriendlySutdModal-cls2_9pQ FriendlySutdModal-cls1_CnL","active":"FriendlySutdModal-active_gqr"};